"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Shades = require("./Shades");
Object.keys(_Shades).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Shades[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Shades[key];
    }
  });
});